import LegalPage from '@components/legal-page';
import { createLegalPageStaticProps } from '@components/legal-page/static-props';
import type { LegalPageProps } from '@components/legal-page/static-props';

const TERMS_PAGE_SLUG = 'terms-and-conditions';

const Terms = ({ page }: LegalPageProps) => {
  if (!page) return null;
  return <LegalPage page={page} />;
};

export const getStaticProps = createLegalPageStaticProps(TERMS_PAGE_SLUG);

export default Terms;
